// extracted by mini-css-extract-plugin
export default {"productoContainer":"Producto_productoContainer__gDMiO","imagenProducto":"Producto_imagenProducto__QM5I2","nombreProducto":"Producto_nombreProducto__M18yz"};